import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { Select, MenuItem } from '@mui/material';
import SimpleModal from '../SimpleModal';
import FolderModal from './FolderModal';
import DeleteModal from './DeleteModal';
import FileViewerModal from './FileViewerModal';
import moment from 'moment';
import LogComponent from '../LogComponent';
import MetaDataComponent from '../MetaDataComponent';
import Upload from './Upload';

import {
    Box,
    Button,
    CardContent,
    Checkbox,
    Grid,
    IconButton,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@mui/material';
import Chip from 'ui-component/extended/Chip';

import MainCard from 'ui-component/cards/MainCard';
import { visuallyHidden } from '@mui/utils';

import SearchIcon from '@mui/icons-material/Search';

import FolderIcon from '@mui/icons-material/Folder';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';

import { fetchUploadedFiles, deleteUploadedFiles, downloadFile } from 'store/slices/uploadedfile';

// import { FileManager } from "@cubone/react-file-manager";
// import "@cubone/react-file-manager/dist/style.css";

// Dummy data
const dataUploadFile = [
    {
        id: 1,
        name: 'Hướng dẫn sử dụng.pdf',
        type: 'pdf',
        crawl_status: 'Done',
        index_status: 'Done',
        created_date: '2023-01-01',
        word_num: 'a'
    },
    {
        id: 2,
        name: 'Văn bản ban hành.pdf',
        type: 'pdf',
        crawl_status: 'Done',
        index_status: 'Done',
        created_date: '2023-11-15',
        word_num: 'b'
    },
    {
        id: 3,
        name: 'Tài liệu hướng dẫn công việc.docx',
        type: 'docx',
        crawl_status: 'Done',
        index_status: 'Processing',
        created_date: '2023-11-23',
        word_num: 'c'
    },
    {
        id: 4,
        name: 'https://www.abc',
        type: 'xml',
        crawl_status: 'Done',
        index_status: 'Processing',
        created_date: '2023-10-25',
        word_num: 'd'
    },
    {
        id: 5,
        name: 'Danh sách danh mục.xlsx',
        type: 'xlsx',
        crawl_status: 'Done',
        index_status: 'Done',
        created_date: '2023-10-23',
        word_num: 'e'
    }
];

const options = [
    { label: 'Tất cả thời gian', value: 'all' },
    { label: '7 ngày trước', value: '7' },
    { label: '30 ngày trước', value: '30' },
    { label: '90 ngày trước', value: '90' }
];

const sortOptions = [
    { label: 'Xếp theo mới nhất', value: 'desc' },
    { label: 'Xếp theo cũ nhất', value: 'asc' }
];
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) =>
    order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
    // Sort folders first, then apply the comparator
    if (!array || !Array.isArray(array)) {
        return [];
    }
    const folders = array.filter((item) => item.file_type === 'folder');
    const files = array.filter((item) => item.file_type !== 'folder');

    const sortedFolders = folders.map((el, index) => [el, index]);
    sortedFolders.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    const sortedFiles = files.map((el, index) => [el, index + folders.length]);
    sortedFiles.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    return [...sortedFolders.map((el) => el[0]), ...sortedFiles.map((el) => el[0])];
}

const headCells = [
    // { id: 'id', numeric: true, label: 'STT', align: 'center' },
    { id: 'file_name', numeric: false, label: 'Tài liệu', align: 'left' },
    { id: 'file_type', numeric: false, label: 'Loại tài liệu', align: 'center' },
    { id: 'file_size', numeric: true, label: 'Kích thước', align: 'center' },
    { id: 'labels', numeric: false, label: 'Nhãn', align: 'center' },
    { id: 'created_date', numeric: false, label: 'Thời gian cập nhật', align: 'center' }
];

const EnhancedTableHead = ({ onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, theme, selected }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox" sx={{ pl: 3 }}>
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts'
                        }}
                    />
                </TableCell>
                {numSelected > 0 && (
                    <TableCell padding="none" colSpan={8}>
                        <EnhancedTableToolbar numSelected={selected.length} />
                    </TableCell>
                )}
                {numSelected <= 0 &&
                    headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ minWidth: 150, padding: 0 }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                sx={{
                                    // fontSize: '0.1rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
            </TableRow>
        </TableHead>
    );
};

EnhancedTableHead.propTypes = {
    theme: PropTypes.object,
    selected: PropTypes.array,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const EnhancedTableToolbar = ({ numSelected, selected }) => (
    <Toolbar
        sx={{
            p: 0,
            pl: 1,
            pr: 1,
            ...(numSelected > 0 && {
                color: (theme) => theme.palette.secondary.main
            })
        }}
    >
        {numSelected > 0 ? (
            <Typography color="inherit" variant="body1">
                Đã chọn {numSelected}
            </Typography>
        ) : (
            <Typography variant="h6" id="tableTitle">
                Nutrition
            </Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
        {/* {numSelected > 0 && (
            <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={() => selected.forEach((name) => handleDelete(name))}>
                    <DeleteIcon fontSize="medium" />
                </IconButton>
            </Tooltip>
        )} */}
    </Toolbar>
);

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};

const apiHost = process.env.REACT_APP_API_URL;

const TableUploadFile = ({ onClick, folderName, projectSubname, dataUploadFile, isSetting }) => {
    const [metaDataOpen, setMetaDataOpen] = useState(false);
    const [logOpen, setLogOpen] = useState(false);
    const [originalRows, setOriginalRows] = useState(dataUploadFile);
    const [hideTableUploadFile, setHideTableUploadFile] = useState(false);
    const [open, setOpen] = useState(false);
    const [openFolder, setOpenFolder] = useState(false);
    const [sort, setSort] = useState('desc');
    const [timeRange, setTimeRange] = useState('all');
    const theme = useTheme();
    // const dispatch = () => { };
    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('file_type');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [search, setSearch] = useState('');
    const [rows, setRows] = useState(dataUploadFile || []);
    const [success, setSuccess] = useState(false);
    const [fileName, setFileName] = useState('');
    const [uploadModalState, setUploadModalState] = React.useState('INACTIVE');
    const [folderModalState, setFolderModalState] = React.useState('INACTIVE');
    const [pathFolder, setPathFolder] = React.useState(folderName);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [fileViewerOpen, setFileViewerOpen] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);

    const uploadedFilesState = useSelector((state) => state.uploadedFile);

    useEffect(() => {
        if (uploadedFilesState?.uploadedFile) {
            setRows(Array.isArray(uploadedFilesState.uploadedFile) ? uploadedFilesState.uploadedFile : []);
            setSuccess(uploadedFilesState.isSuccess);
        } else {
            setRows([]);
        }

        // console.log(uploadedFilesState?.uploadedFile)
    }, [uploadedFilesState?.uploadedFile]);

    // const [files, setFiles] = useState([
    //     {
    //       name: "Documents",
    //       isDirectory: true, // Folder
    //       path: "/Documents", // Located in Root directory
    //       updatedAt: "2024-09-09T10:30:00Z", // Last updated time
    //     },
    //     {
    //       name: "Pictures",
    //       isDirectory: true,
    //       path: "/Pictures", // Located in Root directory as well
    //       updatedAt: "2024-09-09T11:00:00Z",
    //     },
    //     {
    //       name: "Pic.png",
    //       isDirectory: false, // File
    //       path: "/Pictures/Pic.png", // Located inside the "Pictures" folder
    //       updatedAt: "2024-09-08T16:45:00Z",
    //       size: 2048, // File size in bytes (example: 2 KB)
    //     },
    //   ]);

    // console.log(dataUploadFile)

    const filterDataByTimeRange = (range) => {
        console.log(range);
        const currentDate = moment();
        let targetDate;

        switch (range) {
            case '7':
                targetDate = currentDate.clone().subtract(7, 'days');
                break;
            case '30':
                targetDate = currentDate.clone().subtract(30, 'days');
                break;
            case '90':
                targetDate = currentDate.clone().subtract(90, 'days');
                break;
            case 'all':
                return originalRows;
            default:
                return [];
        }

        return originalRows.filter((row) => {
            const rowDate = moment(row.created_date, 'DD/MM/YYYY HH:mm:ss', true);
            return rowDate.isValid() && (rowDate.isAfter(targetDate) || rowDate.isSame(targetDate));
        });
    };

    const handleOpenMetaData = (row) => {
        setFileName(row.file_name);
        setMetaDataOpen(true);
        setHideTableUploadFile(!hideTableUploadFile);
    };

    const handleFilter = () => {
        if (timeRange === 'all') {
            setRows(originalRows);
        } else {
            const filteredRows = filterDataByTimeRange(timeRange);
            setRows(filteredRows);
        }
    };

    useEffect(() => {
        handleFilter();
    }, [timeRange, originalRows]);

    const handleTimeRangeChange = (e) => {
        setTimeRange(e.target.value);
        setRows(originalRows);
    };

    const handleDelete = async () => {
        // console.log(pathFolder)
        // console.log(folderName)
        await dispatch(deleteUploadedFiles(folderName, pathFolder, selected.join('|')));
        await dispatch(fetchUploadedFiles(pathFolder));
        setOpenDeleteModal(false);
        setSelected([]);
        // Lọc ra các hàng không chứa name cần xóa
        // const newRows = rows.filter((row) => row.name !== name);
        // setOriginalRows(newRows);
        // // Xóa khỏi mảng đã chọn
        // setSelected(selected.filter((selectedTaiLieu) => selectedTaiLieu !== name));
        // console.log('da xoa', name);
    };
    const handleSearch = (event) => {
        const newString = event?.target.value;
        setSearch(newString || '');

        if (newString) {
            const newRows = rows.filter((row) => {
                let matches = true;

                const properties = ['file_name', 'file_type', 'file_size', 'labels', 'created_date'];
                let containsQuery = false;

                properties.forEach((property) => {
                    if (row[property]?.toString().toLowerCase().includes(newString.toString().toLowerCase())) {
                        containsQuery = true;
                    }
                });

                if (!containsQuery) {
                    matches = false;
                }
                return matches;
            });
            setRows(newRows);
        } else {
            setOriginalRows(rows);
        }
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            if (selected.length > 0) {
                setSelected([]);
            } else {
                const newSelectedId = rows.map((n) => n.file_name);
                setSelected(newSelectedId);
            }
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        console.log(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event?.target.value, 10));
        setPage(0);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - (rows?.length || 0)) : 0;

    const toggleLog = () => {
        setLogOpen(!logOpen);
        setHideTableUploadFile(!hideTableUploadFile);
    };
    const handleBack = () => {
        setLogOpen(false);
        setMetaDataOpen(false);
        setHideTableUploadFile(false);
    };

    return (
        <>
            {isSetting === false && (
                <>
                    {!hideTableUploadFile && (
                        <>
                            <MainCard title={`Tất cả tài liệu / Tài liệu trợ lý ${projectSubname}`} content={false}>
                                <div>
                                    <CardContent>
                                        <Box 
                                            sx={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                gap: 2,
                                                flexWrap: 'wrap',
                                                mb: 2
                                            }}
                                        >
                                            {/* Action Buttons Group */}
                                            <Box 
                                                sx={{ 
                                                    display: 'flex', 
                                                    gap: 1.5,
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="warning"
                                                    onClick={() => {
                                                        console.log('[DEBUG] Current pathFolder:', pathFolder);
                                                        console.log('[DEBUG] pathFolder parts:', pathFolder.split('/'));

                                                        const pathParts = pathFolder.split('/');

                                                        if (pathParts.length > 1) {
                                                            // Remove the last part to go back one level
                                                            const newPath = pathParts.slice(0, pathParts.length - 1).join('/');
                                                            console.log('[DEBUG] Going back to path:', newPath);

                                                            setPathFolder(newPath);
                                                            setPage(0); // Reset page to 0 when going back
                                                            dispatch(fetchUploadedFiles(newPath));
                                                            setSelected([]);
                                                        } else {
                                                            // If we're at root level, go back to project list
                                                            console.log('[DEBUG] At root level, calling onClick()');
                                                            setPage(0); // Reset page when going back to project list
                                                            onClick();
                                                        }
                                                    }}
                                                >
                                                    Trở về
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        setFolderModalState('ACTIVE');
                                                        // console.log(FolderName);
                                                    }}
                                                >
                                                    Tạo folder
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => {
                                                        setUploadModalState('ACTIVE');
                                                        // console.log(FolderName);
                                                    }}
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    disabled={selected.length === 0}
                                                    onClick={() => {
                                                        setOpenDeleteModal(true);
                                                        // console.log(FolderName);
                                                    }}
                                                >
                                                    Xóa
                                                </Button>
                                            </Box>

                                            {/* Filter/Search Group */}
                                            <Box 
                                                sx={{ 
                                                    display: 'flex', 
                                                    gap: 1.5,
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <Select
                                                    size="small"
                                                    value={timeRange}
                                                    onChange={handleTimeRangeChange}
                                                    sx={{ minWidth: 150 }}
                                                >
                                                    {options.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                                <Select
                                                    size="small"
                                                    value={sort}
                                                    onChange={(e) => {
                                                        setSort(e.target.value);
                                                        handleRequestSort(null, 'created_date');
                                                    }}
                                                    sx={{ minWidth: 150 }}
                                                >
                                                    {sortOptions.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <TextField
                                                    size="small"
                                                    sx={{ width: '200px' }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    onChange={handleSearch}
                                                    placeholder="Tìm kiếm"
                                                    value={search}
                                                />
                                            </Box>
                                        </Box>
                                    </CardContent>

                                    <TableContainer>
                                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                                            <EnhancedTableHead
                                                numSelected={selected.length}
                                                order={order}
                                                orderBy={orderBy}
                                                onSelectAllClick={handleSelectAllClick}
                                                onRequestSort={handleRequestSort}
                                                rowCount={rows?.length || 0}
                                                theme={theme}
                                                selected={selected}
                                            />
                                            <TableBody>
                                                {rows && rows.length > 0 ? stableSort(rows, getComparator(order, orderBy))
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row, index) => {
                                                        const isItemSelected = isSelected(row.file_name);
                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                aria-checked={isItemSelected}
                                                                tabIndex={-1}
                                                                key={index}
                                                                selected={isItemSelected}
                                                            >
                                                                <TableCell
                                                                    padding="checkbox"
                                                                    sx={{ pl: 3 }}
                                                                    onClick={(event) => handleClick(event, row.file_name)}
                                                                >
                                                                    <Checkbox
                                                                        color="primary"
                                                                        checked={isItemSelected}
                                                                        inputProps={{
                                                                            'aria-labelledby': labelId
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell
                                                                    component="th"
                                                                    id={labelId}
                                                                    scope="row"
                                                                    // onClick={(event) => handleClick(event, row.file_name)}
                                                                    onClick={() => {
                                                                        if (row.file_type === 'folder') {
                                                                            dispatch(fetchUploadedFiles(pathFolder + '/' + row.file_name))
                                                                                .then(() => {
                                                                                    setSelected([]);
                                                                                    setPage(0); // Reset page when entering folder
                                                                                    if (success) {
                                                                                        setPathFolder(pathFolder + '/' + row.file_name);
                                                                                    }
                                                                                })
                                                                                .catch(console.log);
                                                                        } else {
                                                                            // For viewable file types, open viewer modal
                                                                            const viewableTypes = [
                                                                                'csv',
                                                                                'txt',
                                                                                'log',
                                                                                'json',
                                                                                'xml',
                                                                                'py',
                                                                                'js',
                                                                                'html',
                                                                                'css',
                                                                                'jpg',
                                                                                'jpeg',
                                                                                'png',
                                                                                'gif',
                                                                                'webp',
                                                                                'svg',
                                                                                'pdf',
                                                                                'xlsx',
                                                                                'xls',
                                                                                'docx',
                                                                                'doc'
                                                                            ];
                                                                            if (viewableTypes.includes(row.file_type)) {
                                                                                setSelectedFile({
                                                                                    fileName: row.file_name,
                                                                                    filePath: pathFolder + '/' + row.file_name,
                                                                                    fileType: row.file_type
                                                                                });
                                                                                setFileViewerOpen(true);
                                                                            } else {
                                                                                // For other file types, open in new tab
                                                                                // Use Redux thunk action
                                                                                dispatch(downloadFile(
                                                                                    folderName.replace('/', ''),
                                                                                    pathFolder + '/' + row.file_name,
                                                                                    row.file_name,
                                                                                    true // openInNewTab = true
                                                                                )).catch((error) => {
                                                                                    console.error('Download error:', error);
                                                                                    alert('Failed to open file. Please try again.');
                                                                                });
                                                                            }
                                                                        }
                                                                    }}
                                                                    sx={{ cursor: 'pointer', padding: 0 }}
                                                                >
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900'
                                                                        }}
                                                                    >
                                                                        {row.file_type === 'folder' && (
                                                                            <>
                                                                                <FolderIcon fontSize="small" /> {row.file_name}{' '}
                                                                            </>
                                                                        )}
                                                                        {row.file_type !== 'folder' && <> {row.file_name} </>}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ padding: 0 }}>
                                                                    {row.file_type === 'pdf' && (
                                                                        <Chip label="pdf" size="small" chipcolor="warning" />
                                                                    )}
                                                                    {row.file_type === 'docx' && (
                                                                        <Chip label="docx" size="small" chipcolor="primary" />
                                                                    )}
                                                                    {row.file_type === 'xml' && (
                                                                        <Chip label="xml" size="small" chipcolor="secondary" />
                                                                    )}
                                                                    {row.file_type === 'xlsx' && (
                                                                        <Chip label="xlsx" size="small" chipcolor="success" />
                                                                    )}
                                                                    {row.file_type === 'txt' && (
                                                                        <Chip label="txt" size="small" chipcolor="success" />
                                                                    )}
                                                                    {row.file_type === 'folder' && (
                                                                        <Chip label="Folder" size="small" chipcolor="info" />
                                                                    )}
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ padding: 0 }}>
                                                                    {row.file_size + ' MB'}
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ padding: 0, fontSize: '0.8rem' }}>
                                                                    {row.labels && row.labels.split('|').length > 0 &&
                                                                        row.labels.split('|').map((data, index) => {
                                                                            return (
                                                                                <Chip
                                                                                    label={data}
                                                                                    key={index}
                                                                                    size="small"
                                                                                    chipcolor="secondary"
                                                                                />
                                                                            );
                                                                        })}
                                                                    {(!row.labels || row.labels.length === 0) && (
                                                                        <Chip label={''} size="small" chipcolor="secondary" />
                                                                    )}
                                                                </TableCell>

                                                                <TableCell align="center" sx={{ padding: 0 }}>
                                                                    {row.created_date}
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ padding: 0, minWidth: 100 }}>
                                                                    <Tooltip title="Meta data">
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            aria-label="data"
                                                                            onClick={() => {
                                                                                handleOpenMetaData(row);
                                                                            }}
                                                                        >
                                                                            <ViewHeadlineIcon sx={{ fontSize: '1.3rem' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    {metaDataOpen && <MetaDataComponent />}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    }) : (
                                                        <TableRow>
                                                            <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                                                <Typography variant="body2" color="textSecondary">
                                                                    No files found
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                {emptyRows > 0 && (
                                                    <TableRow
                                                        style={{
                                                            height: 53 * emptyRows
                                                        }}
                                                    >
                                                        <TableCell colSpan={6} />
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                        component="div"
                                        count={rows?.length || 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                    <SimpleModal open={open} closeModal={() => setOpen(false)} />
                                </div>
                            </MainCard>
                            <Upload
                                projectName={folderName.replace('/', '')}
                                projectSubname={projectSubname}
                                modalState={uploadModalState}
                                setModalState={setUploadModalState}
                                pathFolder={pathFolder}
                                // fetchFiles={fetchFiles}
                                fetchUploadedFiles={() => {
                                    dispatch(fetchUploadedFiles(pathFolder));
                                }}
                            ></Upload>
                            <FolderModal
                                projectName={folderName.replace('/', '')}
                                projectSubname={projectSubname}
                                modalState={folderModalState}
                                setModalState={setFolderModalState}
                                // fetchFiles={fetchFiles}
                                Objects={dataUploadFile}
                                pathFolder={pathFolder}
                                fetchUploadedFiles={() => {
                                    dispatch(fetchUploadedFiles(pathFolder));
                                }}
                            ></FolderModal>
                            <DeleteModal
                                open={openDeleteModal}
                                dataDelete={selected}
                                closeModal={() => setOpenDeleteModal(false)}
                                handleConfirm={handleDelete}
                            />
                            {selectedFile && (
                                <FileViewerModal
                                    open={fileViewerOpen}
                                    onClose={() => {
                                        setFileViewerOpen(false);
                                        setSelectedFile(null);
                                    }}
                                    fileName={selectedFile.fileName}
                                    filePath={selectedFile.filePath}
                                    fileType={selectedFile.fileType}
                                    folderName={folderName}
                                />
                            )}
                        </>
                    )}
                </>
            )}

            {isSetting === true && (
                <div>
                    {/* <TableContainer>
                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                                theme={theme}
                                selected={selected}
                            />
                            <TableBody>
                                {rows && rows.length > 0 ? stableSort(rows, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        const isItemSelected = isSelected(row.file_name);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={index}
                                                selected={isItemSelected}
                                            >
                                                <TableCell
                                                    padding="checkbox"
                                                    sx={{ pl: 3 }}
                                                    onClick={(event) => handleClick(event, row.file_name)}
                                                >
                                                    <Checkbox
                                                        color="primary"
                                                        checked={isItemSelected}
                                                        inputProps={{
                                                            'aria-labelledby': labelId
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    onClick={(event) => handleClick(event, row.file_name)}
                                                    sx={{ cursor: 'pointer', padding: 0, fontSize: '0.8rem' }}
                                                >
                                                    <Typography
                                                        variant="subtitle1"
                                                        sx={{
                                                            color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900',
                                                            fontSize: '0.8rem'
                                                        }}
                                                    >
                                                        {' '}
                                                        {row.file_name}{' '}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center" sx={{ padding: 0, fontSize: '0.8rem' }}>
                                                    {row.file_type === 'pdf' && <Chip label="pdf" size="small" chipcolor="warning" />}
                                                    {row.file_type === 'docx' && <Chip label="docx" size="small" chipcolor="primary" />}
                                                    {row.file_type === 'xml' && <Chip label="xml" size="small" chipcolor="secondary" />}
                                                    {row.file_type === 'xlsx' && <Chip label="xlsx" size="small" chipcolor="success" />}
                                                    {row.file_type === 'folder' && <Chip label="Folder" size="small" chipcolor="info" />}
                                                    {row.file_type === 'txt' && (
                                                        <Chip label="txt" size="small" chipcolor="success" />
                                                    )}
                                                </TableCell>                                  
                                                <TableCell align="center" sx={{ padding: 0, fontSize: '0.8rem' }}>
                                                    {row.file_size + 'MB'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ padding: 0, fontSize: '0.8rem' }}>
                                                    {row.labels && row.labels.split('|').length > 0 && (
                                                        row.labels.split('|').map((data, index) => {
                                                            return <Chip label={data} key={index} size="small" chipcolor="secondary" />
                                                        })
                                                    )}
                                                    {(!row.labels || row.labels.length === 0) && (<Chip label={""} size="small" chipcolor="secondary" />)}
                                                </TableCell>
                                                <TableCell align="center" sx={{ padding: 0, fontSize: '0.8rem' }}>
                                                    {row.created_date}
                                                </TableCell>                                                
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{
                                            height: 53 * emptyRows
                                        }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer> */}

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={rows?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    <SimpleModal open={open} closeModal={() => setOpen(false)} />
                </div>
            )}
            {logOpen && <LogComponent onBack={handleBack} />}
            {metaDataOpen && <MetaDataComponent onBack={handleBack} folerName={folderName} fileName={fileName} />}
        </>
    );
};

export default TableUploadFile;
